import angular from 'angular';
import topVltGamesWidgetModule from './top-vlt-games/top-vlt-games-widget-module';
import financialStatusWidgetModule from './financial-status/financial-status-widget-module';
import siteOperationalStatusWidgetModule from './site-operational-status/site-operational-status-widget-module';
import ticketsWidgetModule from './tickets/tickets-widget-module';
import configurableLinkWidgetModule from './configurable-link/configurable-link-widget-module';
import earningsWidgetModule from './earnings/earnings-widget-module';
import eftAmountWidgetModule from './eft-amount/eft-amount-widget-module';
import jackpotsNextDrawsWidgetModule from './jackpots-next-draws/jackpots-next-draws-widget-module';
import netSalesWidgetModule from './net-sales/net-sales-widget-module';
import bigWinnersWidgetModule from './big-winners/big-winners-widget-module';
import cumulativeWinnersWidgetModule from './cumulative-winners/cumulative-winners-widget-module';
import currentInstantGameLiabilityWidgetModule from './current-instant-game-liability/current-instant-game-liability-widget-module';
import actualAndProjectedSettlementsWidgetModule from './actual-and-projected-settlements/actual-and-projected-settlements-widget-module';
import newGamesWidgetModule from './new-games/new-games-widget-module';
import mySlowMovingGamesWidgetModule from './my-slow-moving-games/my-slow-moving-games-widget-module';
import myPricePointMixWidgetModule from './my-price-point-mix/my-price-point-mix-widget-module';
import myNetSalesPerformanceWidgetModule from './my-net-sales-performance/my-net-sales-performance-widget-module.ts';
import viewFullGameInventoryWidgetModule from './view-full-game-inventory/view-full-game-inventory-widget-module';
import topSellingGamesWidgetModule from './top-selling-games/top-selling-games-widget-module';
import messagesWidgetModule from './messages/messages-widget-module';
import lotteryRepresentativesWidgetModule from './lottery-representatives/lottery-representatives-widget-module';
import selfServiceOutOfStockWidgetModule from './self-service-out-of-stock/self-service-out-of-stock-widget-module';
import licenseRenewalWidgetModule from './license-renewal/license-renewal-widget-module';
import bondRenewalWidgetModule from './bond-renewal/bond-renewal-widget-module';
import sellingTerminalsModule from './selling-terminals/selling-terminals-widget-module';
import chainSalesRankWidgetModule from './chain-sales-rank/chain-sales-rank-widget-module';
import storeSalesRankWidgetModule from './store-sales-rank/store-sales-rank-widget-module';
import endOfGameWidgetModule from './end-of-game/end-of-game-widget-module';
import lvmSalesWidgetModule from './lvm-sales/lvm-sales-module';
import alertsWidgetModule from './alerts/alerts-widget-module';
import announcementsWidgetModule from './announcements/announcements-module';
import gamesEndingWidgetModule from './games-ending/games-ending-widget-module';
import myInstantTicketSalesWidgetModule from './my-instant-ticket-sales/my-instant-ticket-sales-widget-module';
import CommonWidgetComponent from '../common/common-widget/common-widget-component';

export default angular
  .module('dashboard-widget', [
    topVltGamesWidgetModule.name,
    financialStatusWidgetModule.name,
    siteOperationalStatusWidgetModule.name,
    ticketsWidgetModule.name,
    configurableLinkWidgetModule.name,
    earningsWidgetModule.name,
    eftAmountWidgetModule.name,
    jackpotsNextDrawsWidgetModule.name,
    netSalesWidgetModule.name,
    bigWinnersWidgetModule.name,
    cumulativeWinnersWidgetModule.name,
    currentInstantGameLiabilityWidgetModule.name,
    actualAndProjectedSettlementsWidgetModule.name,
    newGamesWidgetModule.name,
    mySlowMovingGamesWidgetModule.name,
    myPricePointMixWidgetModule.name,
    myNetSalesPerformanceWidgetModule.name,
    viewFullGameInventoryWidgetModule.name,
    topSellingGamesWidgetModule.name,
    messagesWidgetModule.name,
    lotteryRepresentativesWidgetModule.name,
    selfServiceOutOfStockWidgetModule.name,
    licenseRenewalWidgetModule.name,
    bondRenewalWidgetModule.name,
    sellingTerminalsModule.name,
    chainSalesRankWidgetModule.name,
    storeSalesRankWidgetModule.name,
    endOfGameWidgetModule.name,
    lvmSalesWidgetModule.name,
    alertsWidgetModule.name,
    announcementsWidgetModule.name,
    gamesEndingWidgetModule.name,
    myInstantTicketSalesWidgetModule.name,
  ])
  .component('commonWidget', new CommonWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/dashboard-widget-module.js